export default function SinAcceso() {
  return <div style={{ padding: 24 }}>No tienes permisos para ver esta sección.</div>;
}